import { call, put, takeEvery } from "redux-saga/effects";
import { lopApi } from "../../../api/category/lopApi";
import { ILopUpdateCTDTRequest } from "../../../model/request/category/ILopUpdateCTDTRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { IStuLopNamHocActionTypes, eStuLopNamHocActionIds } from './../../action-types/category/IStuLopNamHocActions';

export function* lopNamHocSaga(): any {
  yield takeEvery(eStuLopNamHocActionIds.LOAD_START, loadWorker);
  yield takeEvery(eStuLopNamHocActionIds.UPDATE_CTDT_START, updateCTDTWorker);
}

function* loadWorker(action: IStuLopNamHocActionTypes): any {
  const res: IBaseRespone = yield call(lopApi.SelectByNamHoc, action.payload as string);
  if (res.is_success) {
    yield put(rootActions.category.lopNamHoc.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.lopNamHoc.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}


function* updateCTDTWorker(action: IStuLopNamHocActionTypes): any {
  const res: IBaseRespone = yield call(lopApi.UpdateCTDT, action.payload as ILopUpdateCTDTRequest);
  if (res.is_success) {
    yield put(rootActions.category.lopNamHoc.UPDATE_CTDT_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.lopNamHoc.UPDATE_CTDT_ERRR(res.message ?? "Có lỗi")
    );
  }
}
